import * as React from 'react'
import FilterSelect from '@chegg-wt/core/components/FilterSelect'
import { SELECT_WRAPPER_ID } from '@chegg-wt/core/components/Select/ids'
import sourceTypes from '@chegg-wt/core/constants/sourceTypes'
import { sourceTypeById } from '@chegg-wt/core/utils/sourceTypes'
import { AppRoute, SourceType } from '@chegg-wt/core/types/core'
import { DropdownTrigger, ButtonText, SearchLabel, Chevron } from './styled'
import { SOURCE_TYPE_SELECT } from './utils/testIds'

interface SourceTypeSelectProps {
  onChangeSourceType: (source: SourceType) => void
  sourceType: SourceType
  composeRoute?: (sourceType: SourceType) => AppRoute
}

export default function SourceTypeSelect({
  onChangeSourceType,
  sourceType,
  composeRoute,
}: SourceTypeSelectProps) {
  const sourceTypeOptions = sourceTypes.map((sourceType) => ({
    ...sourceType,
    linkedRoute: composeRoute ? composeRoute(sourceType) : undefined,
  }))

  const handleChange = (id: string) => {
    onChangeSourceType(sourceTypeById(id))
  }
  const Trigger = ({ openDropdown, selected, isOpen }) => (
    <DropdownTrigger
      isOpen={isOpen}
      onClick={openDropdown}
      data-test={SOURCE_TYPE_SELECT}
      aria-expanded={isOpen}
    >
      <ButtonText>{selected.name}</ButtonText>
      <div>
        <Chevron size="xsmall" pointing={isOpen ? 'up' : 'down'} />
      </div>
    </DropdownTrigger>
  )

  const SOURCE_TYPE = 'source-type'

  return (
    <div>
      <SearchLabel htmlFor={SELECT_WRAPPER_ID(SOURCE_TYPE)}>Source type</SearchLabel>
      <FilterSelect
        onSelect={handleChange}
        options={sourceTypeOptions}
        trigger={Trigger}
        defaultOption={sourceType}
        dropdownAlignment="left"
        type={SOURCE_TYPE}
        renderOptionAsLink={!!composeRoute}
        isDropdownVisuallyHiddenOnInitialRender={!!composeRoute}
      />
    </div>
  )
}
